import { action, makeObservable, observable } from 'mobx';

import type { GroupSelectStore } from '../group-select/GroupSelect.store';

import type { TFilterState } from './types';

const coordinators = new WeakMap<GroupSelectStore, FilterCoordinator>();

/** Group-scoped applied filter state for well-list, reference wells, and other consumers. */
export function getFilterCoordinator(groupSelectStore: GroupSelectStore): FilterCoordinator {
  let coordinator = coordinators.get(groupSelectStore);

  if (!coordinator) {
    coordinator = new FilterCoordinator();
    coordinators.set(groupSelectStore, coordinator);
  }

  return coordinator;
}

export class FilterCoordinator {
  @observable.ref private statesByGroupId: Map<string, TFilterState> = new Map();

  constructor() {
    makeObservable(this);
  }

  getState(groupId: string | null): TFilterState | null {
    if (groupId === null) {
      return null;
    }

    return this.statesByGroupId.get(groupId) ?? null;
  }

  @action.bound
  publish(groupId: string, state: TFilterState): void {
    if (state.length === 0) {
      this.statesByGroupId.delete(groupId);
      this.statesByGroupId = new Map(this.statesByGroupId);
      return;
    }

    this.statesByGroupId.set(groupId, state);
    this.statesByGroupId = new Map(this.statesByGroupId);
  }

  @action.bound
  clear(groupId: string): void {
    if (!this.statesByGroupId.has(groupId)) {
      return;
    }

    this.statesByGroupId.delete(groupId);
    this.statesByGroupId = new Map(this.statesByGroupId);
  }
}
